/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export { applyRenamedV2Keys, applyV1ColorUpgrades, isV2PrimitiveKey, renameCollidingV2Keys, upgradeV1ColorsToV2 } from './upgrade-v1-primitive-and-semantic-colors';
export { applyV1ComponentColorUpgrades, upgradeV1ComponentColorsToV2 } from './upgrade-v1-component-colors';
export { mergeV2Colors } from './merge-v2-colors';
export { upgradeV1TypographyToV2 } from './upgrade-v1-typography-to-v2';